export default "__VITE_ASSET__DBbFE7VB__"